import { useQuery } from '@apollo/client';
import { useCurrentAccount } from '@application/api';
import { graphql } from '@gql/gql';
import type {
  MtAnimalsBreederGetAnimalsQuery,
  MtAnimalsBreederGetAnimalsQueryVariables,
} from '@gql/graphql';
import { SortOrder } from '@gql/graphql';
import { useMemo } from 'react';

export const MT_ANIMALS_BREEDER_GET_ANIMALS = graphql(`
  query MtAnimalsBreederGetAnimals(
    $orderBy: AnimalOrderByWithRelationAndSearchRelevanceInput
    $animalsWhere: AnimalWhereInput
  ) {
    accountMe {
      id
      animals(orderBy: $orderBy, where: $animalsWhere) {
        id
        type
        name
        birthday
        gender
        archived

        studInfos {
          id
          availableForBreeding
        }

        imgs {
          id
          small
        }
      }
    }
  }
`);

export const useGetAnimals = (archived = false) => {
  const { currentAccount } = useCurrentAccount();

  const variables = useMemo((): MtAnimalsBreederGetAnimalsQueryVariables => {
    return {
      orderBy: { createdAt: SortOrder.desc },
      animalsWhere: {
        archived: { equals: archived },
      },
    };
  }, [archived]);

  const { data, error, loading } = useQuery<
    MtAnimalsBreederGetAnimalsQuery,
    MtAnimalsBreederGetAnimalsQueryVariables
  >(MT_ANIMALS_BREEDER_GET_ANIMALS, {
    variables,
    skip: !currentAccount,
    fetchPolicy: 'network-only',
  });

  return {
    animals: data?.accountMe?.animals,
    animalsError: error,
    animalsLoading: loading,
    animalsVariables: variables,
  };
};
